import React from 'react'
import PropTypes from 'prop-types'
import css from './reviews-box.css'

const positivePercent = (reviews) => {
  const positiveCount = reviews.filter(review => (
    review.positive || review.stars > 3
  )).length
  return `${((positiveCount / (reviews.length || 1)) * 100).toFixed()}%`
}

const FormattedReviewsData = ({ type, data }) => (
  <div>
    <div className={css.sectionHeading}>By {type}</div>
    {data.map(docOrLoc => (
      <div
        key={docOrLoc.id}
        className={css.table}
      >
        <div className={css.name}>{docOrLoc.name}</div>
        <div className={css.row}>
          <span className={css.cell}>Total Reviews</span>
          <span className={css.cell}>{docOrLoc.reviews.length}</span>
        </div>
        <div className={css.row}>
          <span className={css.cell}>Positive Reviews</span>
          <span className={css.cell}>{positivePercent(docOrLoc.reviews)}</span>
        </div>
      </div>
    ))}
  </div>
)

FormattedReviewsData.propTypes = {
  data: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    reviews: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.number.isRequired,
      positive: PropTypes.bool,
      stars: PropTypes.number,
    })),
  })),
  type: PropTypes.oneOf(['doctor', 'location']).isRequired,
}

export default FormattedReviewsData



// WEBPACK FOOTER //
// ./src/components/Dashboard/FormattedReviewsData.js